import React, { FC, memo } from 'react'
import classnames from 'classnames'
import { Container } from '@mch-group/uikit-components'
import styled from 'styled-components'
import { AddToCollectionContext } from '@components/collections/AddToCollection'
import { ActionsBar } from '@components'
import { ButtonIcon } from '@mch-group/uikit-components'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import { getSiteLanguage } from '@utils/storage'
import ShowsInfo from './ShowsInfo'
import CitiesInfo from './CitiesInfo'

const mID = 'ot-gallery-detail-title'

const Title: FC<IGalleryTitle> = memo(({ className, pageMetaInfo: gallery, lastExhibitionLabel }) => {
  const { showAddToCollectionModal } = React.useContext(AddToCollectionContext)
  const { labels } = useLabelsFromAPI(['AltTags'], getSiteLanguage())

  return (
    gallery && (
      <section className={classnames(`${mID} my-10 my-md-14`, className)}>
        <Container className='px-5 mx-md-auto px-lg-8 px-md-7'>
          <Heading>
            <StyledHeader>
              <h1>{gallery.name}</h1>
              {/** @ts-ignore */}
              <CitiesInfo addresses={gallery.coordinatesArray} />
            </StyledHeader>
            <ActionsBarStyled
              className='actions-bar'
              controls={[
                {
                  key: 'Share'
                },
                {
                  key: 'Add to Collection',
                  icon: () => (
                    <ButtonIcon
                      size='lg'
                      variant='outline'
                      icon='collections-add'
                      //@ts-ignore
                      onClick={() => showAddToCollectionModal(gallery.id, 1)}
                      //@ts-ignore
                      title={labels?.addToCollection || 'Add to Collection'}
                    />
                  ),
                  type: 'link'
                }
              ]}
            />
          </Heading>
          <div className={`${mID}__info-bar`}>
            {gallery?.accountId && (
              <ShowsInfo
                //@ts-ignore
                galleryIsActive={gallery.status && gallery.status.active}
                lastExhibitionLabel={lastExhibitionLabel}
                galleryAccountId={gallery?.accountId}
              />
            )}
          </div>
        </Container>
      </section>
    )
  )
})
Title.displayName = 'ProfileTitle'

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${global.uikitVars.breakpointSmMax}) {
    display: block;
  }
`
const ActionsBarStyled = styled(ActionsBar)`
  @media (min-width: ${global.uikitVars.breakpointLg}) {
    margin-left: auto;
    align-self: center;
  }

  @media (max-width: ${global.uikitVars.breakpointSmMax}) {
    margin-top: 32px;
  }
`

const StyledHeader = styled.div`
  &&& {
    @media (max-width: ${global.uikitVars.breakpointMdMax}) {
      align-items: baseline;
      justify-content: space-between;
    }
  }
`

interface IGalleryTitle {
  className?: string
  pageMetaInfo?: any
  lastExhibitionLabel?: string
}

export default styled(Title)`
  &&& {
    .${mID}__info-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: ${global.uikitVars.breakpointMdMax}) {
        align-items: flex-start;
        flex-direction: column;
      }
    }
  }
`
